import {Record, List} from 'immutable';

// Trying to define an validation api..
// TODO replace manual validation with some schema validation
// library
const maxLength = 280;
export function validate(question) {
  const textErrors = [];
  (question.text || '').trim() === '' && textErrors.push('This field is required');

  question.text &&
    question.text.length > maxLength &&
    textErrors.push(`Please rewrite your question to be ${maxLength} chars or less`);

  return textErrors.length > 0
    ? {
        text: textErrors,
      }
    : null;
}

export default class Question extends Record({
  id: null,
  text: null,
  active: null,
  allowComments: false,
  skills: List(),
  skillIds: List(),
  reasonScheme: null,
  cardReasonSchemeId: null,
}) {
  constructor(object = {}) {
    super(
      Object.assign({}, object, {
        skills: List(object.skills || []),
        skillIds: List(object.skillIds || []),
      })
    );
  }
}
